import { combineReducers } from "redux";
import maps from "./mapReducer";
import ecosystems from "./ecosystemReducer";
import companies from "./companyReducer";

export default combineReducers({
  maps,
  companies,
  ecosystems
});